import api from '../../apiConfig/apiConfig';
import { Post, Delete, Put, Get, Patch } from '../base/baseAjax';

// 新建
let addInspection = params => {
	return Post({
		url: api.inspection.addInspection,
		bodyParam: params,
	});
};

// 编辑
let editInspection = ({ id, params }) => {
	return Put({
		url: api.inspection.editInspection,
		bodyParam: params,
		PathParam: {
			id,
		},
	});
};

// 删除
let delInspection = ({ id }) => {
	return Delete({
		url: api.inspection.delInspection,
		PathParam: {
			id,
		},
	});
};

// 修改巡检客户
let editInspectionCustomer = ({ id, customerId }) => {
	return Patch({
		url: api.inspection.editInspectionCustomer,
		bodyParam: {
			customerId,
		},
		PathParam: {
			id,
		},
	});
};

// 历史记录列表
let getInspectionHistoryList = params => {
	return Get({
		url: api.inspection.getInspectionHistoryList,
		UrlParam: params,
	});
};

export default {
	addInspection,
	editInspection,
	delInspection,
	getInspectionHistoryList,
	editInspectionCustomer,
};
